module.exports = __webpack_public_path__ + "bf.a6dec3ee.svg";